import { Box, Button, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { Fragment, useEffect, useState } from 'react'
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import ReadOnlyRow from './components/ReadOnlyRow';
import EditRow from './components/EditRow';
import { EnviarIngresarAlmacen } from '../../../actions/almacen';

const AlmacenTabla3 = ({ currentUser, dispatch, filas, setFilas }) => {

    const [editRowId, setEditRowId] = useState(null);
    const [subtotal, setSubtotal] = useState(0);

    //const widths = {id: 30, producto: 160, vencimiento: 90, ubicacion: 90, cantidad: 100, costo: 100, total:90, controles: 100}

    useEffect(() => {
        //console.log({ filas });
        setSubtotal(filas.reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue.total), 0,).toFixed(2));
        //console.log(subtotal);
    }, [filas])

    const headCells = [
        {
            id: 'id',
            numeric: true,
            type: 'numeric',
            disablePadding: true,
            label: 'Id',
            align: 'left',
            visible: true,
            width: '30',
        },
        {
            id: 'codBar',
            numeric: false,
            type: 'text',
            disablePadding: true,
            label: 'Cod Barras',
            align: 'left',
            visible: true,
            width: '100',
        },
        {
            id: 'product',
            numeric: false,
            type: 'text',
            disablePadding: true,
            label: 'Producto',
            align: 'left',
            visible: true,
            width: '220',
        },
        {
            id: 'vencimiento',
            numeric: true,
            type: 'date',
            disablePadding: false,
            label: 'Vencimiento',
            align: 'center',
            visible: true,
            width: '90',
        },
        {
            id: 'ubicacion',
            numeric: true,
            type: 'text',
            disablePadding: false,
            label: 'Ubicación',
            align: 'left',
            visible: true,
            width: '60',
        },
        {
            id: 'cantidad',
            numeric: true,
            type: 'numeric',
            disablePadding: false,
            label: 'Cantidad',
            align: 'right',
            visible: true,
            width: '60',
        },
        {
            id: 'costo',
            numeric: true,
            type: 'numeric',
            disablePadding: false,
            label: 'Costo',
            align: 'right',
            visible: true,
            width: '100',
        },
        {
            id: 'total',
            numeric: true,
            type: 'numeric',
            disablePadding: false,
            label: 'Total',
            align: 'right',
            visible: true,
            width: '70',
        },
        {
            id: 'controles',
            numeric: false,
            type: 'text',
            disablePadding: false,
            label: 'Controles',
            align: 'left',
            visible: true,
            width: '100',
        },

    ];

    //Genera un objeto con los anchos de las columnas.
    const getColWidths = (columns) => {
        const obj = {}
        columns.forEach((column, index) => {
            obj[column.id] = column.width;
        });
        return obj;
    }

    const colWidths = getColWidths(headCells);

    function ccyFormat(num) {
        return `${num.toFixed(2)}`;
    }


    const handleUpdate = (newRow) => {
        setFilas(filas.map((fila) => newRow.id === fila.id ? newRow : fila));
        setEditRowId(null);
    }

    const handleDeleteClick = (event, row) => {
        event.preventDefault();
        //console.log({row, filas})
        const filasTemp = filas.filter((fila) => fila.id != row.id)
        setFilas(filasTemp);
        //setEditRowId(null);
    }

    const handleEditClick = (event, row) => {
        event.preventDefault();
        setEditRowId(row.id);
    }

    const handleCancelClick = (event, row) => {
        event.preventDefault();
        //console.log({row, filas})
        setEditRowId(null);
    }

    const handleGuardarTodoClick = async (event) => {
        event.preventDefault();
        //console.log({ filas });

        try {
            const result = await EnviarIngresarAlmacen(filas, currentUser, dispatch);
            //console.log("Respuesta del servidor: ", result.rows);

            if (result) {
                const mensaje = 'Se ingresaron los productos al almacen.'
                setFilas([]);
                dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'success', message: mensaje } });
            }
        } catch (error) {
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: 'Error M030: No se pudo ingresar a almacen. Compruebe su conexión.' } });
        }
    }

    const handleCancelarTodoClick = async (event) => {
        event.preventDefault();
        //console.log({ filas });
        const mensaje = 'No se ingreso ningún producto al almacen.'
        setFilas([]);
        dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'success', message: mensaje } });
    }

return (
    <Fragment>
        <Stack
            //direction='column' bgcolor='white' height='100%' sx={{ justifyContent: 'space-between' }}
            direction='column' bgcolor='white' height='100%' sx={{ justifyContent: 'space-between', alignItems: 'center' }}
        >
            <Box
                //m='auto' 
                style={{ height: 500, maxWidth: '1200px', backgroundColor: 'white' }}
            >
                <Typography mb={2} variant="h5" component="h5" p={2} align='center'>
                    Detalle de Productos
                </Typography>
                <TableContainer>
                    <Table size='small'>
                        <TableHead>
                            <TableRow>
                                {headCells.map((headCell) => (
                                    <TableCell key={headCell.label} width={headCell.width} align={headCell.align}>
                                        {headCell.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filas?.map((row) => (
                                <Fragment key={'selrow_' + row.id}>
                                    {editRowId === row.id ?
                                        <EditRow
                                            key={'editrow_' + row.id}
                                            row={row}
                                            colWidths={colWidths}
                                            handleUpdate={handleUpdate}
                                            handleCancelClick={handleCancelClick}
                                        />
                                        : <ReadOnlyRow
                                            key={'rorow_' + row.id}
                                            row={row}
                                            colWidths={colWidths}
                                            handleEditClick={handleEditClick}
                                            handleDeleteClick={handleDeleteClick}
                                        />
                                    }
                                </Fragment>


                            ))}

                            {filas.length > 0 &&
                                <Fragment>
                                    <TableRow hover={true}>
                                        <TableCell rowSpan={3} colSpan={4} style={{ borderBottom: "none", borderRight: "0px solid green" }}> </TableCell>
                                        <TableCell colSpan={3}>Subtotal</TableCell>
                                        <TableCell align="right">{subtotal}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan={2}>Descuento</TableCell>
                                        {/*<TableCell align="right">{`${(0.7 * 100).toFixed(0)} %`}</TableCell>*/}
                                        <TableCell align="right">{`0 %`}</TableCell>
                                        <TableCell align="right">{ccyFormat(0.00)}</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ border: 0 }}>
                                        <TableCell colSpan={3} variant='head' sx={{ color: 'blue' }}>Total</TableCell>
                                        <TableCell align="right" variant='head' sx={{ color: 'blue' }}>{subtotal}</TableCell>
                                    </TableRow>
                                </Fragment>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>





            </Box>

            <Box width='100%' backgroundColor='#fafafa' sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: '1px solid lightgray', borderRadius: 1 }}>
                <Box width={'40%'} m={2} maxWidth={'200px'}>
                    <Button
                        disabled={filas.length < 1}
                        variant='outlined'
                        fullWidth={true}
                        onClick={handleCancelarTodoClick}
                        startIcon={<CancelIcon />}
                    >
                        Cancelar
                    </Button>
                </Box>
                <Box width={'40%'} m={2} maxWidth={'200px'}>
                    <Button
                        disabled={filas.length < 1}
                        variant='outlined'
                        fullWidth={true}
                        onClick={handleGuardarTodoClick}
                        startIcon={<SaveIcon />}
                    >
                        Guardar Todo
                    </Button>
                </Box>
            </Box>

        </Stack>
    </Fragment>
)
}

export default AlmacenTabla3